/* eslint-disable import/prefer-default-export */

import { getAxiosInstance } from 'utils/getAxiosInstance';

export const axiosInstance = getAxiosInstance;
